import React, { useEffect, useState, useRef } from 'react'
import {
    Table,
    Container,
    Row,
    Progress,
} from 'reactstrap';

import DetailTable from 'components/Orders/DetailTable';
import BatchCard from 'components/Orders/BatchCard';
import CreateOrder from './CreateOrder';
import AddBatch from './AddBatch';
import EditOrder from './EditOrder';
import EditBatch from './EditBatch';
import VerificationModal from '../../components/Common/VerificationModal';
import SearchBar from 'components/Common/SearchBar';
import api from 'api';
import { toast } from 'react-toastify';
import Spinner from "components/Spinner/Spinner";
import { baseUrl } from "../../config";
import moment from "moment";
import axios from "axios";
import { MenuItem, Pagination, PaginationItem, Select } from "@mui/material";
import ArrowBack from "../../assets/LeftArrow.svg";
import { ReactComponent as Arrow } from "../../assets/img/Arrowdown.svg"
import ArrowForward from "../../assets/RIghtArrow.svg";
import { UpdateStore } from 'StoreContext';
import { Store } from 'StoreContext';


const Orders = () => {
    const [orders, setOrders] = useState([]);
    const [filterOrders, setFilterOrders] = useState([]);
    const [search, setSearch] = useState();
    const update = UpdateStore()
    const { totalRecords } = Store()
    const [page, setPage] = useState(1);
    const pageSize = 20;
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const orderSentinelRef = useRef(null);
    const [expandedMobileOrders, setExpandedMobileOrders] = useState({});
    const [progress, setProgress] = useState(0);
    const [approveLoading, setApproveLoading] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [createOrder, setCreateOrder] = useState(false);
    const [editOrder, setEditOrder] = useState(false);
    const [editBatchOrder, setEditBatchOrder] = useState(false);
    const [openAddBatch, setOpenAddBatch] = useState(false);
    const [openVerification, setOpenVerification] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState()
    const [codeSearch, setCodeSearch] = useState('');
    const [codeResult, setCodeResult] = useState(null);
    const [codeSearching, setCodeSearching] = useState(false);

    const handleCodeSearch = async () => {
        if (!codeSearch.trim()) return;
        setCodeSearching(true);
        try {
            const res = await api('get', `/codes/lookup?code=${encodeURIComponent(codeSearch.trim())}`);
            setCodeResult(res);
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Code not found');
            setCodeResult(null);
        }
        setCodeSearching(false);
    };

    const handleChange = (e) => {
        setSearch(e.target.value)
    }

    const getOrders = (pageNum, append) => {
        setLoading(true)
        api('get', `/orders?page=${pageNum || page}&pageSize=${pageSize}`).then((res) => {
            setLoading(false)
            const newOrders = res?.orders || [];
            if (append) {
                setOrders(prev => [...prev, ...newOrders]);
                setFilterOrders(prev => [...prev, ...newOrders]);
            } else {
                setOrders(newOrders);
                setFilterOrders(newOrders);
            }
            setHasMore(newOrders.length >= pageSize);
            update({ totalRecords: res.totalRecords });
        }).catch((err) => {
            setLoading(false)
            toast.error(err?.response?.data?.message || 'Failed to load orders')
        })
    }
    // const handleValidateAPI = (selectedOption, batchId, orderId) => {
    //     console.log(selectedOption, batchId, orderId)
    //     if (selectedOption === "pending") {
    //         return toast.error("Order is in pending state")
    //     }
    //     if (!batchId) {
    //         return toast.error("No batch found")
    //     }
    //     if (!orderId) {
    //         return toast.error("No order found")
    //     }
    //     // requestApproveLoading
    //     if (selectedOption === "approved") {
    //         api("patch", `/requests/approveOrderRequest/${batchId}`)
    //             .then((res) => {
    //                 toast.success(res.message)
    //                 getOrders();

    //             })
    //             .catch(() => {
    //                 // requestApproveLoading

    //             });
    //     }


    // }
    const handleExportorderBatchcode = async (id, brandName, reqName, item) => {
        setExportLoading(true);
        setProgress(5);
        try {
            const requestIds = Array.isArray(id) ? id.join(',') : id;
            // Use a dedicated axios instance to avoid global defaults mutation aborting the request
            const exportAxios = axios.create();
            const response = await exportAxios.get(
                `${baseUrl}/codes/exportOrderCode?request=${requestIds}`,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token') || localStorage.getItem('Brandtoken')}`,
                    },
                    onDownloadProgress: (progressEvent) => {
                        if (progressEvent.total) {
                            const pct = (progressEvent.loaded / progressEvent.total) * 100;
                            setProgress(pct);
                        } else {
                            const mb = progressEvent.loaded / (1024 * 1024);
                            setProgress(Math.min(mb * 10, 95));
                        }
                    },
                }
            );
            const currentDate = moment().format("MM_DD_yyyy");
            const baseFileName = `${brandName}_${currentDate}`.replace(/ /g, "_");

            // Check if response has actual data
            if (!response.data || response.data.size === 0) {
                setProgress(0);
                setExportLoading(false);
                toast.error("Export returned empty file — no codes found for this batch");
                return;
            }

            // Detect if response is zip or csv based on content type
            const contentType = response.headers['content-type'] || '';
            const isZip = contentType.includes('zip') || contentType.includes('octet-stream');
            const fileExt = isZip ? '.zip' : '.csv';
            const blobType = isZip ? 'application/zip' : 'text/csv';

            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: blobType })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${baseFileName}${fileExt}`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

            setProgress(0);
            setExportLoading(false);
            toast.success("Codes exported successfully");
        } catch (error) {
            setProgress(0);
            setExportLoading(false);
            console.log("Error downloading the file:", error);
            toast.error("Failed to download the file");
        }
    };

    // Code generation progress tracking
    const checkBatchStatus = (batchId, intervalSeconds) => {
        const interval = setInterval(() => {
            api("patch", `/requests/requestStatus/${batchId}`)
                .then((res) => {
                    if (res.request?.generated_code_by_increase && res.codesGenerated) {
                        const pct = (res.codesGenerated / res.request.generated_code_by_increase) * 100;
                        setProgress(pct);
                    }
                    if (res.request?.status === "approved") {
                        setProgress(0);
                        setApproveLoading(false);
                        toast.success("Codes generated successfully");
                        getOrders();
                        clearInterval(interval);
                    }
                })
                .catch(() => {
                    setProgress(0);
                    setApproveLoading(false);
                    clearInterval(interval);
                });
        }, intervalSeconds * 1000);
    };

    const handleApproveCallback = (batchId) => {
        setApproveLoading(true);
        setProgress(2);
        // Poll based on batch size — larger batches need longer intervals
        checkBatchStatus(batchId, 10);
    };

    // The mobile cards have no status dropdown (that lives in the desktop table's
    // CustomSelect), so a batch could not be approved from a phone. Same API call
    // the dropdown makes, behind a confirm because it generates the codes.
    const handleApproveMobile = (item) => {
        const pendingBatch = item.batchIds?.find(b => b.status === 'pending');
        if (!pendingBatch) return toast.error("No pending batch on this order");
        if (approveLoading) return toast.error("Another batch is still generating — wait for it to finish");
        const n = Number(pendingBatch.generated_code_by_increase || pendingBatch.number_of_codes || 0).toLocaleString();
        if (!window.confirm(`Approve this batch and generate ${n} codes for ${item.brandId?.name || 'this brand'}?`)) return;
        api("patch", `/requests/approveOrderRequest/${pendingBatch._id}`)
            .then((res) => {
                toast.success(res.message || "Code generation started");
                handleApproveCallback(pendingBatch._id);
            })
            .catch((err) => toast.error(err?.response?.data?.message || "Failed to approve batch"));
    };
    const onChangePage = (event, newPage) => {
        setPage(newPage);
    };
    // const handleApprove = (item) => {
    //     // requestApproveLoading
    //     updateStore({
    //         exportLoading: true,
    //     });
    //     setApproveloading(true)
    //     api("patch", `/requests/approve/${item?._id}`)
    //         .then(() => {
    //             // toast.success("Request is in processing");
    //             getRequests();
    //             setProgress(4.5);
    //             if (item?.generated_code_by_increase < 20) {
    //                 checkStatus(item?._id, 5);
    //             } else {
    //                 checkStatus(item?._id, 20);
    //             }
    //         })
    //         .catch(() => {
    //             // requestApproveLoading
    //             setProgress(0);
    //             updateStore({
    //                 exportLoading: false,
    //             });
    //             setApproveloading(false)
    //         });
    // };



    const [pendingDeleteOrderId, setPendingDeleteOrderId] = useState(null);
    const [orderPinModal, setOrderPinModal] = useState(false);
    const [orderPin, setOrderPin] = useState('');

    const handleDelOrder = (id, pin) => {
        const config = pin ? { data: { pin } } : {};
        axios.delete(`${baseUrl}/orders/${id}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            ...config,
        }).then((res) => {
            toast.success(res.data?.message || 'Order deleted')
            getOrders()
            setOrderPinModal(false);
            setOrderPin('');
        }).catch((err) => {
            if (err?.response?.data?.requiresPin) {
                setPendingDeleteOrderId(id);
                setOrderPinModal(true);
            } else {
                toast.error(err?.response?.data?.message || 'Failed to delete order')
            }
        })
    }
    const [pinModal, setPinModal] = useState(false);
    const [pendingDeleteBatchId, setPendingDeleteBatchId] = useState(null);
    const [adminPin, setAdminPin] = useState('');

    const handleDelBatch = (id, pin) => {
        const config = pin ? { data: { pin } } : {};
        axios.delete(`${baseUrl}/orders/orderBatch/${id}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            ...config,
        }).then((res) => {
            toast.success(res.data?.message || 'Batch deleted')
            getOrders()
            setPinModal(false);
            setAdminPin('');
        }).catch((err) => {
            if (err?.response?.data?.requiresPin) {
                // Batch is approved — prompt for PIN
                setPendingDeleteBatchId(id);
                setPinModal(true);
            } else {
                toast.error(err?.response?.data?.message || 'Failed to delete batch')
            }
        })
    }

    const handlePinConfirm = () => {
        if (!adminPin || adminPin.length < 4) {
            return toast.error('Please enter the admin PIN');
        }
        handleDelBatch(pendingDeleteBatchId, adminPin);
    }

    const handleOrderPinConfirm = () => {
        if (!orderPin || orderPin.length < 4) {
            return toast.error('Please enter the admin PIN');
        }
        handleDelOrder(pendingDeleteOrderId, orderPin);
    }

    const handleModal = () => {
        setCreateOrder((open) => !open);
    };
    const handleBatchModal = (item) => {
        setSelectedOrder(item)
        setOpenAddBatch((open) => !open);
    };
    const handleEditOrder = (item) => {
        setSelectedOrder(item)
        setEditOrder((open) => !open);
    };

    const handleEditBatchOrder = (batch) => {
        setSelectedOrder(batch)
        setEditBatchOrder((open) => !open);
    };
    const handleVerificationModal = () => {
        setOpenVerification((open) => !open);
        setEditOrder(false);
        return openVerification;
    };
    useEffect(() => {
        getOrders(page, page > 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    // Infinite scroll observer
    useEffect(() => {
        if (!orderSentinelRef.current) return;
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasMore && !loading) {
                    setPage(p => p + 1);
                }
            },
            { threshold: 0.1 }
        );
        observer.observe(orderSentinelRef.current);
        return () => observer.disconnect();
    }, [hasMore, loading]);

    useEffect(() => {
        if (search) {
            const filtered = orders?.filter(item =>
                item.brandId?.name?.toLowerCase().includes(search.toLowerCase())
            );
            setFilterOrders(filtered);
        } else {
            setFilterOrders(orders);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    return (
        <>
            <Container fluid>
                {loading && <Spinner />}

                {/* Code Generation / Export Loading Overlay */}
                {(approveLoading || exportLoading) && (
                    <div className="blur-overlay">
                        <div className="progressbarDiv">
                            <p className="prgresstext1">
                                {approveLoading ? "Your codes are being generated" : "Your codes are being exported"}
                            </p>
                            <p className="prgresstext2">
                                {approveLoading
                                    ? "Please wait while the codes are being processed. This may take a few moments for large batches."
                                    : "Please wait while your download is being prepared. Do not refresh the page."}
                            </p>
                            <Progress
                                className="my-2"
                                value={progress}
                                animated
                                style={{
                                    height: "30px",
                                    border: "1px solid #362FD8",
                                    borderRadius: "8px",
                                    backgroundColor: "#f0f0f0",
                                }}
                                barStyle={{
                                    backgroundColor: "#362FD8",
                                }}
                            >
                                {progress === 0
                                    ? "Starting..."
                                    : progress >= 99
                                        ? "Finalizing..."
                                        : `${progress.toFixed(1)}%`}
                            </Progress>
                        </div>
                    </div>
                )}

                <div className='d-flex justify-content-between align-items-center pb-4 '>
                    <h1 className="vs-page-title">Orders</h1>
                    <button
                        onClick={handleModal}
                        className='vs-btn-create'>
                        Create Order
                    </button>
                </div>

                <SearchBar handleChange={handleChange} customClass='pb-4' />

                {/* Code Lookup */}
                <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    padding: '14px 20px',
                    marginBottom: '16px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                    fontFamily: 'Outfit',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#362FD8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                        </svg>
                        <input
                            type="text"
                            value={codeSearch}
                            onChange={(e) => setCodeSearch(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handleCodeSearch()}
                            placeholder="Look up a code — find which batch/order it belongs to"
                            style={{
                                flex: 1,
                                border: 'none',
                                outline: 'none',
                                fontSize: '14px',
                                fontFamily: 'Outfit',
                                backgroundColor: 'transparent',
                            }}
                        />
                        <button
                            onClick={handleCodeSearch}
                            disabled={codeSearching}
                            style={{
                                backgroundColor: '#362FD8',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '6px',
                                padding: '6px 16px',
                                fontSize: '13px',
                                fontWeight: 600,
                                fontFamily: 'Outfit',
                                cursor: 'pointer',
                                opacity: codeSearching ? 0.6 : 1,
                            }}
                        >
                            {codeSearching ? 'Searching...' : 'Search Code'}
                        </button>
                        {codeResult && (
                            <button
                                onClick={() => { setCodeResult(null); setCodeSearch(''); }}
                                style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: '18px', padding: '0 4px' }}
                                title="Dismiss"
                            >
                                &times;
                            </button>
                        )}
                    </div>
                    {codeResult && (
                        <div style={{
                            marginTop: '12px',
                            padding: '12px 16px',
                            backgroundColor: codeResult.found ? '#f0fdf4' : '#fef2f2',
                            borderRadius: '8px',
                            fontSize: '13px',
                            fontFamily: 'Outfit',
                        }}>
                            {codeResult.found ? (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '18px', alignItems: 'center' }}>
                                    <div>
                                        <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Code:</span>{' '}
                                        <span style={{ fontFamily: 'monospace', color: '#362FD8', fontWeight: 600 }}>{codeResult.code?.code}</span>
                                    </div>
                                    <div>
                                        <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Status:</span>{' '}
                                        <span style={{
                                            padding: '2px 10px',
                                            borderRadius: '20px',
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            backgroundColor: codeResult.code?.status === 'validated' ? 'rgba(0,178,7,0.1)' : codeResult.code?.status === 'pending' ? 'rgba(54,47,216,0.1)' : 'rgba(255,0,0,0.1)',
                                            color: codeResult.code?.status === 'validated' ? '#00B207' : codeResult.code?.status === 'pending' ? '#362FD8' : '#dc2626',
                                        }}>{codeResult.code?.status}</span>
                                    </div>
                                    {codeResult.brand && (
                                        <div>
                                            <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Brand:</span>{' '}
                                            <span>{codeResult.brand?.name || codeResult.brand?.email}</span>
                                        </div>
                                    )}
                                    {codeResult.batch && (
                                        <div>
                                            <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Batch:</span>{' '}
                                            <span>{codeResult.batch?.productName || 'Unnamed'}</span>
                                            {codeResult.batch?.numberOfCodes && (
                                                <span style={{ color: '#666', marginLeft: '4px' }}>({codeResult.batch.numberOfCodes} codes)</span>
                                            )}
                                        </div>
                                    )}
                                    {codeResult.order && (
                                        <div>
                                            <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Order:</span>{' '}
                                            <span style={{ color: '#362FD8', fontWeight: 600 }}>{codeResult.order?.orderNumber}</span>
                                        </div>
                                    )}
                                    {codeResult.code?.scanAttempts > 0 && (
                                        <div>
                                            <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Scans:</span>{' '}
                                            <span>{codeResult.code.scanAttempts}</span>
                                        </div>
                                    )}
                                    {codeResult.code?.validationTime && (
                                        <div>
                                            <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Validated:</span>{' '}
                                            <span>{moment(codeResult.code.validationTime).format('MMM D, YYYY')}</span>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div style={{ color: '#dc3545', fontWeight: 500 }}>
                                    Code not found in any batch. Check the code and try again.
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* Desktop Table */}
                <Row className="d-none d-md-block">
                    <div className='col'>
                        <Table style={{ fontFamily: 'Outfit' }} className='align-items-center table-flush' responsive>
                            <thead className='thead-light'>
                                <tr>
                                    <th style={{
                                        borderTop: 'none',
                                        background: 'white',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1C1C1C',
                                        textTransform: 'capitalize',
                                        letterSpacing: 0,
                                        whiteSpace: 'nowrap',
                                        padding: '12px 10px',
                                        borderTopLeftRadius: '10px',
                                        width: '40px',
                                    }} scope='col' />
                                    <th style={{
                                        borderTop: 'none',
                                        background: 'white',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1C1C1C',
                                        textTransform: 'capitalize',
                                        letterSpacing: 0,
                                        whiteSpace: 'nowrap',
                                        padding: '12px 10px',
                                    }} scope='col'>Order ID</th>
                                    <th style={{
                                        borderTop: 'none',
                                        background: 'white',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1C1C1C',
                                        textTransform: 'capitalize',
                                        letterSpacing: 0,
                                        whiteSpace: 'nowrap',
                                        padding: '12px 10px',
                                    }} scope='col'>Brand</th>
                                    <th style={{
                                        borderTop: 'none',
                                        background: 'white',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1C1C1C',
                                        textTransform: 'capitalize',
                                        letterSpacing: 0,
                                        whiteSpace: 'nowrap',
                                        padding: '12px 10px',
                                    }} scope='col'>Batches</th>
                                    <th style={{
                                        borderTop: 'none',
                                        background: 'white',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1C1C1C',
                                        textTransform: 'capitalize',
                                        letterSpacing: 0,
                                        whiteSpace: 'nowrap',
                                        padding: '12px 10px',
                                    }} scope='col'>Codes</th>
                                    <th style={{
                                        borderTop: 'none',
                                        background: 'white',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1C1C1C',
                                        textTransform: 'capitalize',
                                        letterSpacing: 0,
                                        whiteSpace: 'nowrap',
                                        padding: '12px 10px',
                                    }} scope='col'>Scans</th>
                                    <th style={{
                                        borderTop: 'none',
                                        background: 'white',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1C1C1C',
                                        textTransform: 'capitalize',
                                        letterSpacing: 0,
                                        whiteSpace: 'nowrap',
                                        padding: '12px 10px',
                                    }} scope='col'>Status</th>
                                    <th style={{
                                        borderTop: 'none',
                                        background: 'white',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1C1C1C',
                                        textTransform: 'capitalize',
                                        letterSpacing: 0,
                                        whiteSpace: 'nowrap',
                                        padding: '12px 10px',
                                    }} scope='col'>Date</th>
                                    <th style={{
                                        borderTop: 'none',
                                        background: 'white',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1C1C1C',
                                        textTransform: 'capitalize',
                                        letterSpacing: 0,
                                        whiteSpace: 'nowrap',
                                        padding: '12px 10px',
                                    }} scope='col'>Actions</th>
                                    <th style={{
                                        borderTop: 'none',
                                        background: 'white',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1C1C1C',
                                        textTransform: 'capitalize',
                                        letterSpacing: 0,
                                        whiteSpace: 'nowrap',
                                        padding: '12px 10px',
                                        borderTopRightRadius: '10px',
                                    }} scope='col'>Validate</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filterOrders?.map((item, index) => {
                                    return (
                                        <DetailTable
                                            item={item}
                                            arr={orders}
                                            index={index}
                                            handleModal={handleBatchModal}
                                            handleEditOrder={handleEditOrder}
                                            handleEditBatchOrder={handleEditBatchOrder}
                                            handleDelBatch={handleDelBatch}
                                            handleDelOrder={handleDelOrder}
                                            handleExportorderBatchcode={handleExportorderBatchcode}
                                            getOrders={getOrders}
                                            onApproveStart={handleApproveCallback}
                                            allOrders={orders}
                                        />
                                    )
                                })}
                            </tbody>
                        </Table>

                    </div>
                </Row >

                {/* Mobile Cards */}
                <div className="d-block d-md-none" style={{ fontFamily: 'Outfit' }}>
                    {filterOrders?.map((item) => {
                        const hasPending = item.batchIds?.some(b => b.status === 'pending');
                        const hasApproved = item.batchIds?.some(b => b.status === 'approved');
                        const totalCodes = item.batchIds?.reduce((s, b) => s + (b.number_of_codes || 0), 0) || 0;
                        const isExpanded = expandedMobileOrders?.[item._id];
                        return (
                            <div key={item._id} style={{
                                backgroundColor: '#fff', borderRadius: '10px', padding: '14px 16px',
                                marginBottom: '10px', boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                    <div>
                                        <div style={{ fontWeight: 600, fontSize: '14px', color: '#1C1C1C' }}>{item.brandId?.name || 'Order'}</div>
                                        <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>
                                            #{String(item._id).slice(-6)} · {item.batchIds?.length || 0} batch{item.batchIds?.length !== 1 ? 'es' : ''} · {totalCodes.toLocaleString()} codes
                                        </div>
                                    </div>
                                    <span style={{
                                        padding: '3px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 500,
                                        backgroundColor: hasPending ? 'rgba(255,0,0,0.08)' : 'rgba(0,178,7,0.08)',
                                        color: hasPending ? '#dc3545' : '#00B207',
                                    }}>{hasPending ? 'Pending' : 'Approved'}</span>
                                </div>
                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '8px' }}>
                                    {moment(item.createdAt).format('MMM DD, YYYY')}
                                </div>
                                <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                                    <span style={{ cursor: 'pointer', fontSize: '12px', color: '#362FD8' }}
                                        onClick={() => setExpandedMobileOrders(p => ({ ...p, [item._id]: !p?.[item._id] }))}>
                                        {isExpanded ? 'Hide batches' : 'View batches'}
                                    </span>
                                    {hasPending && (
                                        <span style={{ cursor: approveLoading ? 'not-allowed' : 'pointer', fontSize: '12px', fontWeight: 600, color: '#00B207', opacity: approveLoading ? 0.5 : 1 }}
                                            onClick={() => handleApproveMobile(item)}>
                                            {approveLoading ? 'Generating…' : 'Approve'}
                                        </span>
                                    )}
                                    {hasApproved && (
                                        <span style={{ cursor: 'pointer', fontSize: '12px', color: '#362FD8' }}
                                            onClick={() => {
                                                const ids = item.batchIds.filter(b => b.status === 'approved').map(b => b._id);
                                                handleExportorderBatchcode(ids, item.brandId?.name, "batch name", null);
                                            }}>Download</span>
                                    )}
                                    <span style={{ cursor: 'pointer', fontSize: '12px', color: '#dc3545' }}
                                        onClick={() => handleDelOrder(item._id)}>Delete</span>
                                </div>
                                {isExpanded && item.batchIds?.length > 0 && (
                                    <div style={{ marginTop: '10px' }}>
                                        {item.batchIds.map(batch => (
                                            <BatchCard
                                                key={batch._id}
                                                batch={batch}
                                                order={item}
                                                getOrders={getOrders}
                                                onConfirmDelete={(batchId) => handleDelBatch(batchId)}
                                                handleExportorderBatchcode={handleExportorderBatchcode}
                                                allOrders={orders}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                <div ref={orderSentinelRef} style={{ height: '1px' }} />
                {loading && (
                    <div style={{ textAlign: 'center', padding: '16px', fontFamily: 'Outfit', color: '#888', fontSize: '13px' }}>Loading more...</div>
                )}
                {!hasMore && filterOrders?.length > 0 && (
                    <div style={{ textAlign: 'center', padding: '12px', fontFamily: 'Outfit', color: '#aaa', fontSize: '12px' }}>All orders loaded</div>
                )}
            </Container >
            {createOrder && <CreateOrder handleModal={handleModal} getOrders={getOrders} />}
            {openAddBatch && <AddBatch selectedOrder={selectedOrder} handleModal={handleBatchModal} getOrders={getOrders} allOrders={orders} />}
            {editOrder && <EditOrder handleModal={handleEditOrder} handleVerificationModal={handleVerificationModal} selectedOrder={selectedOrder} getOrders={getOrders} />}
            {editBatchOrder && <EditBatch selectedBatch={selectedOrder} handleModal={handleEditBatchOrder} getOrders={getOrders} />}
            {openVerification && <VerificationModal handleModal={handleVerificationModal} />}
            {pinModal && (
                <div style={{ fontFamily: "Outfit", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
                    <div style={{ backgroundColor: "#fff", borderRadius: "20px", padding: "30px", width: "420px", textAlign: "center" }}>
                        <div style={{
                            width: "70px", height: "70px", borderRadius: "50%",
                            backgroundColor: "rgba(220, 38, 38, 0.1)", display: "flex",
                            alignItems: "center", justifyContent: "center", margin: "0 auto 16px",
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                                <line x1="12" y1="9" x2="12" y2="13"/>
                                <line x1="12" y1="17" x2="12.01" y2="17"/>
                            </svg>
                        </div>
                        <h2 style={{ fontFamily: "Outfit", fontWeight: 700, fontSize: "22px", color: "#dc2626", marginBottom: "12px" }}>
                            Permanent Deletion
                        </h2>
                        <div style={{
                            backgroundColor: "#FEF2F2", border: "1px solid #FECACA",
                            borderRadius: "10px", padding: "14px", marginBottom: "16px", textAlign: "left",
                        }}>
                            <p style={{ color: "#991B1B", fontSize: "14px", fontWeight: 600, margin: "0 0 6px 0", fontFamily: "Outfit" }}>
                                This action CANNOT be reversed.
                            </p>
                            <ul style={{ color: "#7F1D1D", fontSize: "13px", margin: 0, paddingLeft: "18px", fontFamily: "Outfit", lineHeight: "1.6" }}>
                                <li>All generated codes will be permanently deleted</li>
                                <li>Dashboard stats and Total Codes will decrease</li>
                                <li>Activity Map scan data will be removed</li>
                                <li>Scan history for these codes will be lost</li>
                            </ul>
                            <p style={{ color: "#991B1B", fontSize: "13px", fontWeight: 600, margin: "10px 0 0 0", fontFamily: "Outfit" }}>
                                Back up your code data before proceeding if needed.
                            </p>
                        </div>
                        <input
                            type="password"
                            value={adminPin}
                            onChange={(e) => setAdminPin(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handlePinConfirm()}
                            placeholder="Enter admin PIN"
                            maxLength={10}
                            autoFocus
                            style={{
                                backgroundColor: "#F3F3F3",
                                border: "none",
                                borderRadius: "8px",
                                fontFamily: "Outfit",
                                width: "100%",
                                padding: "12px 17px",
                                fontSize: "18px",
                                textAlign: "center",
                                letterSpacing: "8px",
                                marginBottom: "20px",
                            }}
                        />
                        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                            <button className="vs-btn-cancel" onClick={() => { setPinModal(false); setAdminPin(''); }} style={{ width: "45%" }}>
                                Cancel
                            </button>
                            <button className="vs-btn-save" onClick={handlePinConfirm} style={{ width: "45%", backgroundColor: "#dc2626" }}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Orders